<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { CriterionEditorViewModel } from "@Criteria/Hierarchies/Components/CriterionEditor"

    // ---------------- props / emits ----------------

    const props = defineProps({
        viewModel: {
            type: Object as PropType<CriterionEditorViewModel>,
            required: true
        }
    })

    const emit = defineEmits<{
        (e: 'delete-criterion', criterionId: number): void
        (e: 'update-criterion', criterionId: number, name: string, description: string): void
    }>()

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)
    const criterionId = computed(() => vm.value.criterionId)
    const isGoal = computed(() => vm.value.isGoal)
    const nameError = computed(() => vm.value.nameError)

    // ---------------- actions ----------------

    function emitDeleteCriterion()
    {
        emit("delete-criterion", criterionId.value!)
    }

    function emitUpdateCriterion()
    {
        vm.value.clearValidationErrors()
        emit("update-criterion", criterionId.value!, vm.value.name, vm.value.description)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit criterion</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="criterion-editor-form" @submit.prevent="emitUpdateCriterion">
                            <div class="form-group">
                                <label>Name <span style="color: red;">*</span></label>
                                <input v-model.trim="vm.name" type="text" class="form-control" required minlength="2" maxlength="100">
                                <div class="error">{{nameError}}</div>
                            </div>

                            <div class="form-group">
                                <label>Description</label>
                                <textarea v-model.trim="vm.description" class="form-control"></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <div class="w-100 text-right">
                            <button v-if="!isGoal" type="button" class="btn btn-danger float-left" @click="emitDeleteCriterion">Delete</button>
                            <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                            <button type="submit" form="criterion-editor-form" class="btn btn-primary">Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>